// @ts-nocheck
/* eslint-disable */
import { node, icon } from "./util/dom";
Mapy.MarkerBubble = function(coords, id, opts) {
	var _opts = {
		angle: 45,
		arrowLength: 32,
		arrowCenter: [16,16],
		bubbleHeight: 32,
		bubbleWidth: 110,
		icon: icon("weather-marker-pointer"),
	};

	for (var p in opts) { _opts[p] = opts[p]; }

	SMap.Marker.call(this, coords, id, _opts);
};

Mapy.MarkerBubble.prototype = Object.create(Object.assign({}, Mapy.MarkerCard.prototype, SMap.Marker.prototype));

Mapy.MarkerBubble.prototype.setArrowAngle = function(angle) {
	if (angle != undefined) {
		this._options.angle = angle;
	}

	let right = this._options.angle > 180;

	this._dom.arrow.classList[right ? "add" : "remove"]("right");

	var degrees = 180 + this._options.angle;
	var al = this._options.arrowLength;

	this._dom.arrow.style.transform = `rotate(${degrees}deg)`;

	if (right) {
		this._options.anchor = {
			right: this._options.arrowCenter[0] - (al*Math.sin(degrees*Math.PI/180)),
			top: this._options.arrowCenter[1] - (al*Math.cos(degrees*Math.PI/180)),
			left: undefined, // kdyby predtim bylo na druhou stranu aby se to nepodelalo
		};
	}
	else {
		this._options.anchor = {
			left: this._options.arrowCenter[0] + (al*Math.sin(degrees*Math.PI/180)),
			top: this._options.arrowCenter[1] - (al*Math.cos(degrees*Math.PI/180)),
			right: undefined, // kdyby predtim bylo na druhou stranu aby se to nepodelalo
		};
	}

	if (this._owner) { this._owner.positionMarker(this); }
}

Mapy.MarkerBubble.prototype.setInnerElement = function(elm) {
	if (elm != undefined) {
		this._options.elm = elm;
	}
	else {
		return;
	}

	var div = this._dom.container[SMap.LAYER_MARKER];

	div.innerHTML = "";

	div.appendChild(this._dom.arrow);
	div.appendChild(this._options.elm);
}

Mapy.MarkerBubble.prototype.setOptions = function(options) {
	this._options = {
		...this._options,
		...options,
	};
}

Mapy.MarkerBubble.prototype.toggleClassName = function(method, className) {
	if (!method) {
		method = "add";
	}
	this._dom.container[SMap.LAYER_MARKER].classList[method](className);
}

Mapy.MarkerBubble.prototype._build = function() {
	var div = node("div", { className: `marker-bubble${this._options.className ? ` ${this._options.className}`:``}` });

	var arrow = node("div", { className: "arrow" });
	arrow.appendChild(this._options.icon);
	div.appendChild(arrow);
	if (this._options.elm) {
		div.appendChild(this._options.elm);
	}

	this._dom.container[SMap.LAYER_MARKER] = div;
	this._dom.arrow = arrow;

	this.setArrowAngle();

	if (this._options.title) { this._dom.container[SMap.LAYER_MARKER].title = this._options.title; }
	this._dom.active = this._dom.container[SMap.LAYER_MARKER];
}
